// ** CRM module translations (react-intl classic system)
import en from './en.json';
import mx from './mx.json';

export default { en, mx };
